// react
import React from "react"
// app
import DatePicker from "components/common/DatePicker"
import TextField from "components/common/TextField"

export default ({
    onEmployerChange ,
    onPositionChange,
    onFromChange,
    onToChange
}) =>
    <div className="clearfix">
        <h4>Add Job History Entry</h4>
        <div className="float-left">
            <TextField
                label="Employer"
                mandatory={ true }
                onChange={ onEmployerChange }
            />
            <br />
            <TextField
                label="Position"
                onChange={ onPositionChange }
                maxLength={ 500 }
            />
        </div>
        <div className="float-right">
            <DatePicker
                label="From"
                mandatory={ true }
                onChange={ onFromChange }
                value=""
            />
            <DatePicker
                label="To"
                onChange={ onToChange }
                value=""
            />
        </div>
    </div>


/** WEBPACK FOOTER **
 ** ./src/components/person/Jobs/add.js
 **/